<template>
    <modal-wrapper modalClass="modal--form" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1 v-if="question.id">{{$t('modals.edit_question.title')}}</h1>
            <h1 v-else>{{$t('modals.create_question.title')}}</h1>
        </div>

        <survey-template-question-form
            :question = "question"
            :wrapperClass="['modal__content']"
            @saved="onQuestionSaved">

            <div class="modal__footer" slot="buttons" slot-scope="{ isSaveDisabled }">
                <div class="actions">
                    <button class="actions__action--save pull-right" type="submit" :class="{disabled: isSaveDisabled}" :disabled="isSaveDisabled">{{$t('common.save')}}</button>
                    <button class="actions__action--cancel" type="button" @click="refetchAndClose">{{$t('modals.common.cancel')}}</button>
                </div>

            </div>
        </survey-template-question-form>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import SurveyTemplateQuestionForm from '@/components/forms/survey-templates/SurveyTemplateQuestionForm';
    import { GET_SURVEY_TEMPLATE } from '@/store/modules/survey-template';

    @Component({
        components: {
            SurveyTemplateQuestionForm,
        }
    })
    export default class SurveyTemplateQuestionModal extends Vue {
        name = 'survey-template-question-modal';

        question = {};

        beforeOpen(event) {
            if (event.params && event.params.question) {
                this.question = event.params.question;
            }
        }

        onQuestionSaved() {
            this.$modal.hide(this.name);
        }

        refetchAndClose() {
            if (this.question.id) {
                this.$store.dispatch(GET_SURVEY_TEMPLATE, {});
            }
            this.$modal.hide(this.name);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/survey-templates/SurveyTemplateQuestionModal.vue